import { makeVar, ReactiveVar } from '@apollo/client';
import { OrganizationFragment, UserFragment } from '@/graphql/generated/graphql';
import { produce } from 'immer';
import { CurrentEmployee, EmployeePermissions } from '@/service/Api/types';

export type UserPermissionsT = {
  isManager?: boolean;
  isAdmin?: boolean;
  isEmployee?: boolean;
  layoutAccess?: EmployeePermissions[];
};

export interface ICurrentUser extends UserFragment {
  permissions: UserPermissionsT;
  isAuthenticated: boolean;
  timezone: {
    utc?: string;
    name: string;
    longName?: string;
  };
  organization: OrganizationFragment;
  error?: Error;
  token?: string | null;
  employeeData?: Omit<CurrentEmployee, 'permissions'>;
}

export const currentUserInitialState: ICurrentUser = {
  id: '',
  newInfraId: '',
  newInfraIdentifier: '',
  isAdmin: false,
  isAuthenticated: false,
  organization: {
    id: '',
    name: '',
    newInfra: true,
    availableRewardTypes: [],
    config: {},
  },
  timezone: {
    name: Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
  permissions: {
    isManager: false,
    isAdmin: false,
    isEmployee: false,
    layoutAccess: [],
  },
};

export const currentUserVar: ReactiveVar<ICurrentUser> = makeVar<ICurrentUser>(currentUserInitialState);

export const setCurrentUser = (payload: Partial<ICurrentUser>) => {
  currentUserVar(
    produce(currentUserVar(), (draft) => ({
      ...draft,
      ...payload,
    }))
  );
};

export const setUserEmployeeData = (payload: CurrentEmployee) => {
  const { permissions, ...rest } = payload;
  currentUserVar(
    produce(currentUserVar(), (draft) => {
      draft.employeeData = {
        ...draft.employeeData,
        ...rest,
      };
      draft.permissions = {
        ...draft.permissions,
        isAdmin: payload.isAdmin,
        isManager: payload.isManager,
        isEmployee: !!rest.id,
        layoutAccess: permissions,
      };
    })
  );
};
